<template>
	<header-menu-admin />
	
	<!-- Main Sections -->
	<main class="main-wrapper bg-lightest-gray">

		<!-- About Section Start -->
		<section class="about-section py-40">
			<div class="container-fluid">
				<div class="top-bar mb-16">
					<router-link :to="{path: '/admin/news'}" class="btn btn-secondary">
						Назад
					</router-link>
				</div>
				<div class="about-wrapper bg-white">
					<div class="about-block">
						<h4 class="mb-12">Добавление новости</h4>
						<form @submit.prevent="onNewsItemAdd" class="contact-form">
							<div class="row">
								<div class="col-md-9">
									<div class="input-block mb-16">
										<label for="title" class="form-label">Заголовок:</label>
										<input type="text" id="title" class="form-control" placeholder="Заголовок" v-model="title" required>
									</div>
								</div>
								<div class="col-md-3">
									<div class="input-block mb-16">
										<label for="date" class="form-label">Дата:</label>
										<input type="datetime-local" id="date" class="form-control" placeholder="Дата" v-model="date" required>
									</div>
								</div>
								<div class="col-md-12">
									<div class="input-block mb-16">
										<label for="description" class="form-label">Текст новости:</label>
										<textarea id="description" cols="8" rows="5" class="form-control" placeholder="Текст новости" v-model="description" required></textarea>
									</div>
								</div>
								<div class="col-md-12">
									<div class="input-block mb-16">
										<label for="poster" class="form-label">Постер:</label>
										<input type="file" id="poster" class="form-control d-block" @change="handleFileChange" required>
									</div>
								</div>
								<div class="col-md-12">
									<button type="submit" class="btn btn-primary" :disabled="btnDisabled">Добавить</button>
								</div>
							</div>
						</form>
						<div class="alert alert-warning alert-dismissible mt-3 mb-0" role="alert" v-if="error">
							{{error}}
							<button type="button" class="btn-close" aria-label="Close" @click="error = ''"></button>
						</div>
					</div>
				</div>
			</div>
		</section>
		<!-- About Section End -->
	</main>
	<!-- Main Sections -->
</template>

<style lang="scss">
      
</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

import HeaderMenuAdmin from '@/components/HeaderMenuAdmin';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'InterMagTech Admin'});
	},
	data: () => ({
		title: '',
		description: '',
		date: '',
		poster: '',
		
		loading: true,
		error: '',
		btnDisabled: false,
	}),
	methods: {
		handleFileChange(event){
			this.poster = event.target.files[0];
		},
		async onNewsItemAdd(){
			this.error = '';
			this.btnDisabled = true;
			
			const params = {
				title: this.title,
				description: this.description,
				date: this.date,
				poster: this.poster,
			};
			const ret = await this.appModel.doAddNewsitem(params);
			this.btnDisabled = false;
			if(ret.success){
				this.$router.push('/admin/news');
			} else {
				this.error = ret.error;
			}
		},
	},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		window.scrollTo(0, 0);
		next();
	},
	components: {
		HeaderMenuAdmin,
	},
};
</script>